import React from "react";
import { withRouter } from "react-router-dom";
import Tooltip from "../../components/tooltip";

import { Container } from "react-grid-system";
import api from "../../services/api";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import estados from "../../services/estados";
import HeaderV2 from "../../components/headerV2";
import Search from "../../components/search";
import ButtonFilterV2 from "../../components/button-filter/indexV2";
import FilterCell from "../../components/FilterCell";
import NotFound from "../../components/NotFound";
import CardCountMetric from "../../components/CardCountMetric";
import TableWithLabelBlackV2 from "../../components/TableWithLabelBlack/indexV2";
import MoreOptions from "../../components/MoreOptions";
import Badge from "../../components/badge";
import { Loading } from "../../components/loading";
import TextOrStatus from "../../components/textOrStatus";
import IconPenEdit from '../../assets/icons/icon-pen-edit.png';
import IconOrder from '../../assets/icons/icon-order.png';
import ButtonOld from "../../components/button";
import Button from "../../components/button/button_v2";
import SwitchLayout from "../../components/SwitchLayout";
import InputSearch from "../../components/input-search";
import Importacao from "../../components/modal/modalImportacao";
import {
    ArtsContainer,
    ProgressBar,
    Progress,
    ContainerFiltersAndButtons,
    ContainerInput,
    FilterLineBreak,
    MetricsRow,
    CardsGrid,
    ArtCard,
    ArtCardTopRow,
    ArtCardTitle,
    ArtCardHeaderRight,
    ArtCardCode,
    ArtCardCodeRow,
    FilterFixedItem,
    ArtCardValidade,
    ArtCardProgressRow,
    ArtCardProgressLabel,
    ArtCardProgressTrack,
    ArtCardProgressFill
} from "./styles";
import ModalTesteGratisAcabou from '../../components/modal/modalFuncaoBloqueada';
import Paginator from "../../components/paginator";
import ModalGeneric from "../../components/modal/modalGeneric";
import { BodyM, H5, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import PaginatorV2 from "../../components/paginator/indexV2";
import { store } from "react-notifications-component";
import downloadFile from "../../utils/downloadFile";
import { max } from "date-fns";

export const USER = "@userinfo";
export const VAL = "@validade";

// Valor de ESTADOS para a opção "Nacional". Não é um sentinela: as ARTs/TRT
// nacionais (CFTA) têm `agro_creas.estado` gravado literalmente como
// 'NACIONAL' no banco - não nulo nem vazio -, então o filtro é uma igualdade
// normal, igual à de qualquer UF.
const ESTADO_NACIONAL = "NACIONAL";

// Rótulo da coluna/pilula ESTADO. 'NACIONAL' vem em caixa alta do banco e,
// com 9 caracteres, estourava a largura da coluna - aqui vira "Nacional",
// do mesmo tamanho que o resto do texto da tela. Estado ausente também cai
// em "Nacional", que é o que ele significa nessa listagem.
const formatarEstado = (estado) => {
    const uf = (estado || '').trim();
    return (!uf || uf.toUpperCase() === ESTADO_NACIONAL) ? 'Nacional' : uf.toUpperCase();
};

// Uma ART/TRT é nacional quando não tem UF própria (CFTA).
const isEstadoNacional = (estado) => formatarEstado(estado) === 'Nacional';

// "Perto do limite" também mora no filtro de SITUAÇÃO, mas não é um valor de
// status de verdade - vira um filtro à parte (perto_do_limite: true) no
// /art/pesquisa, já que é uma diferença entre colunas, não uma igualdade.
const PERTO_DO_LIMITE_VALUE = "__perto_do_limite__";

const situacaoBase = [
    { value: 1, label: "Ativo" },
    { value: 2, label: "Vencida" },
    { value: 0, label: "Inativo" }
];

// Ícones do menu "mais opções" da coluna AÇÕES - traço fino em currentColor
// pra herdar a cor (cinza normal / vermelho na opção de perigo) que o
// MoreOptions já aplica em volta de cada ícone.
const DownloadIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 2V11.5M9 11.5L5.5 8M9 11.5L12.5 8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.5 12.5V14.5C2.5 15.0523 2.94772 15.5 3.5 15.5H14.5C15.0523 15.5 15.5 15.0523 15.5 14.5V12.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

const BanIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="6.5" stroke="currentColor" strokeWidth="1.4" />
        <path d="M4.5 4.5L13.5 13.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
);

const CheckCircleIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="6.5" stroke="currentColor" strokeWidth="1.4" />
        <path d="M6 9.2L8 11.2L12 7.2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

class Arts extends React.Component {
    state = {
        arts: [],
        limit: 30,
        offSet: 0,
        totalPages: 0,
        loading: false,
        loadingMore: false,
        hideButton: false,
        result: "",
        result2: "",
        result3: "",
        result4: "",
        resultEstado: "",
        progressBar: '',
        size_screen: window.screen.width,
        importar: false,
        modalTesteGratisAcabou: false,
        user: JSON.parse(localStorage.getItem(USER)),
        val: JSON.parse(localStorage.getItem(VAL)),
        loadingSearch: false,
        modalRelatorio: false,
        // ART/TRT em confirmação de inativação (null = modal fechado).
        modalInativarArt: null,
        // ART/TRT em confirmação de ativação (null = modal fechado).
        modalAtivarArt: null,
        // Id da ART/TRT cujo documento está sendo gerado no momento (null = nenhuma).
        downloadingArtId: null,
        // true enquanto a chamada de ativar/inativar ART/TRT está em andamento
        // (desabilita os botões do modal de confirmação pra evitar duplo clique).
        togglingArtStatus: false,
        layoutView: window.innerWidth <= 768 ? 'cards' : 'table',
        // Guarda de qual lado do breakpoint mobile estávamos, pra só forçar a
        // troca de layout quando ele muda de fato (não brigar com uma escolha
        // manual do usuário dentro do mesmo tamanho de tela).
        isMobileLayout: window.innerWidth <= 768,
        // Sem filtro nenhum marcado por padrão - "Nacional"/"Todas" continuam
        // disponíveis como opção nos dropdowns, só não vêm pré-selecionadas.
        selectedOptions: { uf: [], situacao: [] },
        openSelect: "",
        stats: { total: 0, ativas: 0, receitasEmitidas: 0, pertoDoLimite: 0, inativadas: 0 },
        statsLoading: true,
        // art_states / art_situation que a própria /art/pesquisa devolve junto com a
        // listagem - usados pra contagem ao lado de cada opção em ESTADOS/SITUAÇÃO.
        filterFacets: { estados: {}, situacao: {} },
    };

    searchDebounce = null;

    componentDidMount() {
        this.setState({ size_screen: window.screen.width });
        this.search('', this.state.limit, 0);
        this.getArtsStats();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Troca automaticamente pra cards ao entrar em largura mobile (e de volta
    // pra tabela ao sair) - só dispara quando o breakpoint muda de verdade.
    handleResize = () => {
        const isMobileLayout = window.innerWidth <= 768;
        this.setState((prevState) => {
            if (prevState.isMobileLayout === isMobileLayout) {
                return { size_screen: window.screen.width };
            }
            return {
                isMobileLayout,
                layoutView: isMobileLayout ? 'cards' : 'table',
                size_screen: window.screen.width
            };
        });
    }

    toggleSelect = (key) => {
        this.setState(({ openSelect }) => ({ openSelect: openSelect === key ? "" : key }));
    }

    // Chamado quando o usuário confirma a seleção pendente no ButtonFilterV2
    // (botão APLICAR). A busca inteira (texto, estado e situação) é sempre
    // refeita no servidor - nada é filtrado no front.
    handleApplyFilter = (key, values) => {
        this.setState(
            (prevState) => ({ selectedOptions: { ...prevState.selectedOptions, [key]: values } }),
            () => this.search(this.state.result, this.state.limit, 0)
        );
    }

    // Monta o "filters.estado" do /art/pesquisa a partir dos ESTADOS
    // selecionados. "Nacional" é uma igualdade como as outras
    // (estado = 'NACIONAL'); já foi um matchMode "vazio", que não casava
    // nada porque o banco grava a string 'NACIONAL', e não vazio/nulo.
    // Com 1 valor selecionado manda uma igualdade simples; com 2+ (Nacional
    // e/ou vários estados juntos) manda um OR - o backend aceita qualquer
    // quantidade de constraints no OR.
    buildEstadoFilter = () => {
        const selecionados = this.state.selectedOptions.uf || [];
        if (selecionados.length === 0) return undefined;

        const constraints = selecionados.map(value => ({ value, matchMode: 'equals' }));

        if (constraints.length === 1) {
            return constraints[0];
        }

        return { operator: 'or', constraints };
    }

    // Monta o "filters.status" a partir da SITUAÇÃO selecionada. São só 3
    // valores reais possíveis (Ativo/Vencida/Inativo) - com nenhum marcado
    // equivale a "sem filtro". PERTO_DO_LIMITE_VALUE não é status de
    // verdade, então sai daqui.
    // Importante: mesmo com os 3 marcados, ainda manda o filtro explícito
    // (OR dos 3) em vez de "sem filtro" - parece redundante (equivale a não
    // filtrar), mas é o que permite o backend combinar certo com "Perto do
    // limite" quando os dois vêm juntos (ex.: GO + Ativo+Vencida+Inativo+
    // Perto do limite): sem o filtro explícito, o backend não sabia que
    // "Ativo" tinha sido escolhido e podia acabar restringindo o resultado
    // só às ARTs perto do limite, te fazendo perder um GO+Ativo que não
    // estava perto do limite.
    buildStatusFilter = () => {
        const situacaoReal = (this.state.selectedOptions.situacao || [])
            .filter(v => v !== PERTO_DO_LIMITE_VALUE);
        if (situacaoReal.length === 0) return undefined;

        if (situacaoReal.length === 1) {
            return { value: situacaoReal[0], matchMode: 'equals' };
        }

        return {
            operator: 'or',
            constraints: situacaoReal.map(value => ({ value, matchMode: 'equals' }))
        };
    }

    // "Perto do limite" vira um flag à parte no payload (não um filters.status).
    buildPertoDoLimiteFlag = () => {
        const situacao = this.state.selectedOptions.situacao || [];
        return situacao.includes(PERTO_DO_LIMITE_VALUE) ? true : undefined;
    }

    // Remove só um valor do resumo de filtros (o "x" de cada pilula no
    // FilterCell), reaplicando o filtro com o restante da seleção.
    handleRemoveFilterValue = (key, value) => {
        const current = this.state.selectedOptions[key] || [];
        this.handleApplyFilter(key, current.filter(v => v !== value));
    }

    // "LIMPAR FILTROS" do FilterCell - zera ESTADOS e SITUAÇÃO de uma vez e
    // refaz a busca uma única vez (setState direto pra não disparar duas
    // pesquisas em sequência, como aconteceria chamando handleApplyFilter
    // duas vezes).
    handleClearAllFilters = () => {
        this.setState(
            { selectedOptions: { uf: [], situacao: [] } },
            () => this.search(this.state.result, this.state.limit, 0)
        );
    }

    getArtsStats = async () => {
        this.setState({ statsLoading: true });

        try {
            const payload = { search: "", estado: "" };
            const response = await api.post(`/art/pesquisa?limit=1000&offset=0`, payload);
            const lista = response?.data?.data?.arts || [];
            const total = response?.data?.data?.total ?? lista.length;

            const ativas = lista.filter(art => Number(art.status) === 1);
            const receitasEmitidas = ativas.reduce((acc, art) => acc + (this.getReceitasInfo(art).numerator || 0), 0);
            // "Perto do limite" = faltam 10 ou menos receitas/contratos pra bater a quantidade total.
            const pertoDoLimite = ativas.filter(art => {
                const { numerator, denominator } = this.getReceitasInfo(art);
                if (!denominator) return false;
                return (denominator - numerator) <= 10;
            }).length;

            // A própria /art/pesquisa já devolve a contagem por situação.
            const artSituation = response?.data?.data?.art_situation || {};

            this.setState({
                stats: {
                    total,
                    ativas: ativas.length,
                    receitasEmitidas,
                    pertoDoLimite,
                    // Uma ART/TRT não é cancelada, só inativada (status 0).
                    inativadas: artSituation.inativo || 0,
                },
                statsLoading: false
            });
        } catch (error) {
            this.setState({ statsLoading: false });
        }
    }

    changeLayoutView = (next) => {
        if (next === this.state.layoutView) return;
        this.setState({ layoutView: next });
    }

    getReceitasInfo = (art) => {
        const isSP = art?.crea?.estado === 'SP';
        const numerator = Number(isSP ? (art?.contratos?.qtde_contratos || 0) : (art?.receitas_emitidas || 0));
        const denominator = Number(isSP ? art?.quantidade_contratos : art?.quantidade_receitas);
        const percent = denominator ? Math.min(100, Math.max(0, (numerator / denominator) * 100)) : 0;

        return {
            numerator,
            denominator: denominator || 0,
            percent,
            label: isSP ? 'CONTRATOS EMITIDOS' : 'RECEITAS EMITIDAS'
        };
    }

    formatDateBR = (value) => {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '-';
        // timeZone UTC pra não perder um dia quando a API manda só a data
        // (sem horário) e o browser interpreta como meia-noite UTC.
        return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    }

    handleEditArt = (art) => {
        const { user, val } = this.state;
        if (user.contract_software_id === 6 && val === 0) {
            this.setState({ modalTesteGratisAcabou: true });
        } else {
            this.props.history.push(`arts/${art.id}`);
        }
    }

    handleBaixarDocumento = async (art) => {
        this.setState({ downloadingArtId: art.id });

        try {
            const response = await api.get(`/arts/relatorio/${art.id}`);
            const link = response?.data?.data;

            if (link) {
                await downloadFile(link, `art-${art.numero_art || art.id}.pdf`);
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-631 Erro ao gerar o documento da ART/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
        } finally {
            this.setState({ downloadingArtId: null });
        }
    }

    // Manda pra tela de Histórico já com o filtro de ART/TRT aplicado
    // (Historico lê o "art_id" da query string e pré-seleciona o filtro).
    handleVerReceitasEmitidas = (art) => {
        this.props.history.push(`/historico?art_id=${art.id}`);
    }

    // Abre o modal de confirmação em vez de já disparar a ação.
    handleInativarArt = (art) => {
        this.setState({ modalInativarArt: art });
    }

    handleCancelInativarArt = () => {
        if (this.state.togglingArtStatus) return;
        this.setState({ modalInativarArt: null });
    }

    // Reaproveita o PUT /arts/:artid (mesma rota da tela de edição completa),
    // mandando só os campos que de fato mudam (status) junto com os que o
    // DTO exige sempre (avisar) - o service já preenche o resto a partir do
    // registro atual (ver editArt em arts.service.ts).
    handleConfirmInativarArt = async () => {
        const art = this.state.modalInativarArt;
        if (!art) return;

        this.setState({ togglingArtStatus: true });

        try {
            await api.put(`/arts/${art.id}`, {
                status: 0,
                avisar: art.avisar,
                qtd_avisar: art.qtd_avisar,
            });

            this.setState({ modalInativarArt: null, togglingArtStatus: false });
            this.search(this.state.result, this.state.limit, 0);

            store.addNotification({
                title: "Sucesso!",
                message: "ART/TRT inativada com sucesso!",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
        } catch (error) {
            this.setState({ togglingArtStatus: false });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-632 Erro ao inativar a ART/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
        }
    }

    // Mesmo esquema de confirmação, pro caminho inverso (ART/TRT já inativa).
    handleAtivarArt = (art) => {
        this.setState({ modalAtivarArt: art });
    }

    handleCancelAtivarArt = () => {
        if (this.state.togglingArtStatus) return;
        this.setState({ modalAtivarArt: null });
    }

    handleConfirmAtivarArt = async () => {
        const art = this.state.modalAtivarArt;
        if (!art) return;

        this.setState({ togglingArtStatus: true });

        try {
            await api.put(`/arts/${art.id}`, {
                status: 1,
                avisar: art.avisar,
                qtd_avisar: art.qtd_avisar,
            });

            this.setState({ modalAtivarArt: null, togglingArtStatus: false });
            this.search(this.state.result, this.state.limit, 0);

            store.addNotification({
                title: "Sucesso!",
                message: "ART/TRT ativada com sucesso!",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
        } catch (error) {
            this.setState({ togglingArtStatus: false });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-633 Erro ao ativar a ART/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
        }
    }

    updateResposta = async (resposta) => {
        if (resposta == 0) {
            this.setState({ importar: false })
        }
    }

    onSearchInputChange = (text) => {
        this.setState({ result: text });
        if (this.searchDebounce) clearTimeout(this.searchDebounce);
        this.searchDebounce = setTimeout(() => {
            this.search(text, this.state.limit, 0);
        }, 300);
    }

    onSearchClear = () => {
        if (this.searchDebounce) clearTimeout(this.searchDebounce);
        this.setState({ result: "" });
        this.search("", this.state.limit, 0);
    }

    calculateProgress = (receitasEmitidas, quantidadeReceitas, quantidadeContratos, totalContratos) => {
        if ((receitasEmitidas >= 0) && (quantidadeReceitas || quantidadeContratos)) {

            if (!quantidadeContratos) {
                let porcentagemReceitasEmitidas = ((receitasEmitidas * 100) / quantidadeReceitas);
                let subProgress = ((120 * porcentagemReceitasEmitidas) / 100);
                let value = 120 - subProgress;

                let progress = parseInt(value);

                return progress + "px";

            } else {


                if (totalContratos) {
                    let porcentagemReceitasEmitidas = ((totalContratos * 100) / quantidadeContratos);
                    let subProgress = ((120 * porcentagemReceitasEmitidas) / 100);
                    let value = 120 - subProgress;
                    let progress = parseInt(value);
                    return progress + "px";
                } else {
                    let porcentagemReceitasEmitidas = ((0 * 100) / quantidadeContratos);
                    let subProgress = ((120 * porcentagemReceitasEmitidas) / 100);
                    let value = 120 - subProgress;
                    let progress = parseInt(value);
                    return progress + "px";
                }
            }
        }
    }

    getArts = async () => {

        try {
            const { limit } = this.state;
            const response = await api.get("/arts?limit=" + limit);
            const arts = response.data.data;

            if (arts && arts.length > 0) {
                this.setState({ arts, loadingSearch: false, hideButton: false });
            } else {
                this.setState({ loadingSearch: false, hideButton: false });
            }
        } catch (error) {
            this.setState({ loadingSearch: false, hideButton: true });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-626 Erro ao carregar as ARTs/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    // Busca sempre no servidor - texto, ESTADOS e SITUAÇÃO viram o "search" e
    // o "filters" do corpo do /art/pesquisa; nenhum filtro é aplicado no
    // front sobre o resultado.
    search = async (text, limit, offset) => {

        this.setState({ arts: [], loadingSearch: true })

        try {
            const filters = {};

            const estadoFilter = this.buildEstadoFilter();
            if (estadoFilter) filters.estado = estadoFilter;

            const statusFilter = this.buildStatusFilter();
            if (statusFilter) filters.status = statusFilter;

            const pertoDoLimite = this.buildPertoDoLimiteFlag();

            const payload = {
                search: text,
                estado: '',
                ...(Object.keys(filters).length > 0 ? { filters } : {}),
                ...(pertoDoLimite ? { perto_do_limite: true } : {})
            };

            const response = await api.post(`/art/pesquisa?limit=${limit}&offset=${offset}`, payload);

            this.setState({
                totalPages: response.data.data.total,
                arts: response.data.data.arts,
                filterFacets: {
                    estados: response.data.data.art_states || {},
                    situacao: response.data.data.art_situation || {}
                },
                loadingSearch: false
            });
        } catch (error) {
            this.setState({ loadingSearch: false });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-627 Erro ao pesquisar ARTs/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }

    };

    getXlms = async () => {
        this.setState({ loading: true });
        window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';
        try {
            const response = await api.get("/relatorios/arts");

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-arts.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 6000, onScreen: true }
            });
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-628 Erro ao gerar o relatorio de ARTs - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            this.setState({ loading: false });
            window.onbeforeunload = null;
        }
    };

    handleConfirmRelatorio = async () => {
        this.setState({ loading: true, modalRelatorio: false });
        window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';
        try {
            const response = await api.get("/relatorios/arts");

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-arts.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 6000, onScreen: true }
            });

        } catch (error) {
             store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    error,
                    "ERRO-629 Erro ao gerar o relatorio de ARTs - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            this.setState({ loading: false });
            window.onbeforeunload = null;
        }
    };

    cleanFilter = () => {
        this.setState({
            result: "",
            result2: "",
            result3: "",
            result4: "",
            offSet: 0
        });
        this.serch('', '', 30, 0);
    };

    loadMore = async () => {
        this.setState({ loadingMore: true, hideButton: true });
        const { limit, offSet, arts } = this.state;
        const newOffset = limit + offSet;

        try {
            const response = await api.get(
                "/arts?limit=" + limit + "&offset=" + newOffset
            );
            let newArts = response.data.data;
            const artsConCat = arts.concat(newArts);
            this.setState({
                arts: artsConCat,
                offSet: newOffset,
                hideButton: false
            });
        } catch (erro) {
            this.setState({
                hideButton: true
            });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(
                    erro,
                    "ERRO-630 Erro ao carregar mais ARTs/TRT - Tente novamente, se o erro persistir acione o suporte."
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
        this.setState({ loadingMore: false });
    };

    onKeyDown = (e) => {
        // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            if (this.searchDebounce) clearTimeout(this.searchDebounce);
            this.search(this.state.result, this.state.limit, 0);
        }
    }

    openAdd = () => {
        this.props.history.push('/arts/add');
    }

    updateLimitOffset = (l, o) => {
        if (l !== this.state.limit || o !== this.state.offset) {
            this.setState({
                limit: l,
                offset: o
            })

            this.search(this.state.result, l, o);
        }
    }

    render() {
        const {
            arts,
            loadingSearch,
            hideButton,
            result,
            size_screen,
            importar,
            modalTesteGratisAcabou,
            limit,
            totalPages,
            modalRelatorio,
            modalInativarArt,
            modalAtivarArt,
            togglingArtStatus,
            downloadingArtId,
            loading,
            layoutView,
            stats,
            statsLoading,
            filterFacets
        } = this.state;

        const emailUser = JSON.parse(localStorage.getItem("@userinfo"));

        const columns = [
            {
                key: 'status',
                label: 'Status',
                minWidth: '110px',
                width: '110px',
                render: (art) => {
                    const isVencida = Number(art.status) === 2;
                    const isAtivo = Number(art.status) === 1;

                    return (
                        <TextOrStatus
                            type="status"
                            status={isAtivo ? 2 : 3}
                            textSuccess="Ativo"
                            textError={isVencida ? "Vencida" : "Inativo"}
                            maxWidth="auto"
                        />
                    );
                }
            },
            {
                key: 'rt',
                label: 'Responsáveis técnicos',
                minWidth: '220px',
                maxWidthContent: "260px",
                width: '100%',
                enableHorizontalScroll: true,
                render: (art) => {
                    const nome = art?.crea?.agronomo?.nome || '-';
                    const isActive = Number(art.status) === 1;
                    return (
                        <BodyM color={isActive ? theme.colors.gray.Cinza_2 : theme.colors.disabled.Desabilitado_Medio} fontWeight={800}>
                            {isActive ? nome : <strike>{nome}</strike>}
                        </BodyM>
                    );
                }
            },
            {
                key: 'tipo',
                label: 'Tipo',
                minWidth: '150px',
                render: (art) => {
                    const tipo = art?.crea?.tipo;
                    const creaNum = art?.crea?.crea || '-';
                    const creaLabel = tipo === 'crea' ? `Crea: ${creaNum}` : tipo === 'visto' ? `Visto: ${creaNum}` : `Cfta: ${creaNum}`;
                    const isActive = Number(art.status) === 1;
                    return (
                        <TaglineP color={isActive ? theme.colors.gray.Cinza_5 : theme.colors.disabled.Desabilitado_Medio} fontWeight={600}>
                            {creaLabel}
                        </TaglineP>
                    );
                }
            },
            {
                key: 'numero',
                label: 'Número',
                width: '100%',
                minWidth: '160px',
                maxWidth: '170px',
                maxWidthContent: "170px",
                enableHorizontalScroll: true,
                render: (art) => {
                    const texto = `${art.numero_art}${art.apelido ? ` - ${art.apelido}` : ''}`;
                    return Number(art.status) !== 1 ? (
                        <TaglineP color={theme.colors.disabled.Desabilitado_Medio} fontWeight={600}>
                            <strike>{texto}</strike>
                        </TaglineP>
                    ) : (
                        <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>{texto}</TaglineP>
                    );
                }
            },
            {
                key: 'loja',
                label: 'Loja',
                width: '100%',
                // +50% (120px/130px -> 180px/195px) - a maioria dos nomes de loja
                // estava cortando e precisando de scroll horizontal na célula.
                minWidth: '180px',
                maxWidth: '195px',
                maxWidthContent: "195px",
                enableHorizontalScroll: true,
                render: (art) => {
                    const nomeLoja = art?.crea?.agronomo?.filial?.nome_fantasia || '-';
                    return Number(art.status) !== 1 ? (
                        <TaglineP color={theme.colors.disabled.Desabilitado_Medio} fontWeight={600}>
                            <strike>{nomeLoja}</strike>
                        </TaglineP>
                    ) : (
                        <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>{nomeLoja}</TaglineP>
                    );
                }
            },
            {
                key: 'estado',
                label: 'Estado',
                minWidth: '100px',
                render: (art) => (
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '4px 12px',
                        borderRadius: '10rem',
                        backgroundColor: Number(art.status) === 1 ? theme.colors.gray.Cinza_2 : theme.colors.disabled.Desabilitado_Medio,
                        color: '#fff',
                        fontSize: '11px',
                        fontWeight: '700',
                        letterSpacing: '0.5px',
                        whiteSpace: 'nowrap'
                    }}>
                        {formatarEstado(art?.crea?.estado)}
                    </div>
                )
            },
            {
                key: 'receitas',
                label: 'Receitas emitidas/Contratos',
                minWidth: '220px',
                render: (art) => (
                    <div>
                        <ProgressBar progress={this.calculateProgress(art.receitas_emitidas, art.quantidade_receitas, art.quantidade_contratos, art.contratos.qtde_contratos)}>
                            <Progress />
                        </ProgressBar>
                        <div style={{ width: '185px', marginLeft: '15px', marginTop: '4px', fontSize: '13px', color: theme.colors.gray.Cinza_5, whiteSpace: 'nowrap' }}>
                            {art.crea.estado === 'SP' ? (
                                <>{art.contratos.qtde_contratos ? art.contratos.qtde_contratos : 0} / {art.quantidade_contratos} - <label style={{ fontSize: '9px', fontStyle: 'italic', color: '#bac1cf', fontWeight: 'bold' }}> CONTRATOS EMITIDOS </label></>
                            ) : (
                                <>{art.receitas_emitidas} / {art.quantidade_receitas} - <label style={{ fontSize: '9px', fontStyle: 'italic', color: '#bac1cf', fontWeight: 'bold' }}> RECEITAS EMITIDAS </label></>
                            )}
                        </div>
                    </div>
                )
            }
        ];

        // art_states / art_situation vêm prontos do /art/pesquisa (mesma chamada que
        // já busca a listagem) - "nacional" pras ARTs sem estado, siglas em minúsculo
        // pro resto, e "todos"/"ativo"/"vencida"/"inativo" em SITUAÇÃO.
        const artStates = filterFacets.estados || {};
        const artSituation = filterFacets.situacao || {};

        const estadoOptionsComContagem = [
            { value: ESTADO_NACIONAL, label: "Nacional", count: artStates.nacional || 0 },
            ...Object.keys(artStates)
                .filter(uf => uf !== 'nacional')
                .map(uf => ({
                    value: uf.toUpperCase(),
                    label: estados.find(e => e.value === uf.toUpperCase())?.label || uf.toUpperCase(),
                    count: artStates[uf]
                }))
                .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'))
        ];

        const situacaoKeyByValue = { 1: 'ativo', 2: 'vencida', 0: 'inativo' };
        const situacaoOptionsComContagem = [
            ...situacaoBase.map(option => ({
                ...option,
                count: artSituation[situacaoKeyByValue[option.value]] || 0
            })),
            { value: PERTO_DO_LIMITE_VALUE, label: "Perto do limite", count: artSituation.perto_do_limite || 0 }
        ];

        const buildFilterChipLabel = (key, value) => {
            if (value === ESTADO_NACIONAL) return 'Nacional';
            if (value === PERTO_DO_LIMITE_VALUE) return 'Perto do limite';
            if (key === 'uf') return value;
            return situacaoBase.find(option => option.value === value)?.label || value;
        };

        const filterChipItems = [
            ...(this.state.selectedOptions.uf || []).map(value => ({
                id: `uf_${value}`,
                label: buildFilterChipLabel('uf', value),
                onRemove: () => this.handleRemoveFilterValue('uf', value)
            })),
            ...(this.state.selectedOptions.situacao || []).map(value => ({
                id: `situacao_${value}`,
                label: buildFilterChipLabel('situacao', value),
                onRemove: () => this.handleRemoveFilterValue('situacao', value)
            }))
        ];

        return (
            <>
                <HeaderV2 title="ARTs/TRT" />

                <ArtsContainer isIndex={true}>
                    <Container style={size_screen <= 768 ? { paddingLeft: "0px", paddingRight: "0px", margin: 'auto' } : {}}>

                        <Importacao
                            style={{ display: "flex", justifyContent: "center" }}
                            show={importar}
                            onHide={e => { this.setState({ importar: false }) }}
                            step={1}
                            fields={[
                                "Estado",
                                "Responsável Técnico",
                                "CREA/Visto/CFTA",
                                "Número ART",
                                "Receita Inicial",
                                "Quantidade de contratos",
                                "Número da ordem",
                                "Produtor",
                                "Local de Aplicação",
                                "Valor do contrato",
                                "Data Inicial",
                                "Data Final"
                            ]}
                            resposta=''
                            update={this.updateResposta}
                            title='Importar ARTs/TRT'
                        ></Importacao>

                        <ContainerFiltersAndButtons>
                            <FilterFixedItem>
                                <SwitchLayout
                                    isTableView={layoutView === 'table'}
                                    onClick={() => this.changeLayoutView(layoutView === 'table' ? 'cards' : 'table')}
                                />
                            </FilterFixedItem>

                            <ContainerInput>
                                <Search
                                    placeholder="Número, responsável técnico, loja ou CREA/Visto"
                                    value={result}
                                    onChange={(e) => this.onSearchInputChange(e.target.value)}
                                    onKeyDown={(e) => this.onKeyDown(e)}
                                    onClear={() => this.onSearchClear()}
                                />
                            </ContainerInput>

                            <FilterLineBreak />

                            <FilterFixedItem>
                                <ButtonFilterV2
                                    key_value="uf"
                                    selectedOptions={this.state.selectedOptions}
                                    label="ESTADOS"
                                    options={{ uf: estadoOptionsComContagem }}
                                    toggleSelect={this.toggleSelect}
                                    openSelect={this.state.openSelect}
                                    onApply={this.handleApplyFilter}
                                    searchPlaceholder="Buscar estado"
                                />
                            </FilterFixedItem>

                            <FilterFixedItem>
                                <ButtonFilterV2
                                    key_value="situacao"
                                    selectedOptions={this.state.selectedOptions}
                                    label="SITUAÇÃO"
                                    options={{ situacao: situacaoOptionsComContagem }}
                                    toggleSelect={this.toggleSelect}
                                    openSelect={this.state.openSelect}
                                    onApply={this.handleApplyFilter}
                                    searchPlaceholder="Buscar situação"
                                />
                            </FilterFixedItem>

                            <FilterFixedItem>
                                <Button
                                    width={window.innerWidth <= 760 ? 'auto' : '170px'}
                                    height='42px'
                                    value='ADICIONAR'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => this.openAdd()}
                                    loading={false}
                                    imagePlus={window.innerWidth > 760 || window.innerWidth <= 375}
                                />
                            </FilterFixedItem>

                            <FilterFixedItem hideOnMobile>
                                <Button
                                    width='140px'
                                    height='42px'
                                    value='RELATÓRIO'
                                    outline={!loading}
                                    disabled={false}
                                    onClick={() => this.getXlms()}
                                    loading={loading}
                                    color="#21262f"
                                />
                            </FilterFixedItem>
                        </ContainerFiltersAndButtons>

                        <FilterCell
                            items={filterChipItems}
                            onClearAll={filterChipItems.length > 0 ? this.handleClearAllFilters : undefined}
                        />

                        <MetricsRow>
                            <CardCountMetric
                                title="ARTs/TRT ativas"
                                value={statsLoading ? '-' : stats.ativas}
                                subtitle={`de ${stats.total} cadastradas`}
                                loading={statsLoading}
                            />
                            <CardCountMetric
                                title="Receitas/contratos emitidos"
                                value={statsLoading ? '-' : stats.receitasEmitidas}
                                subtitle="no total de receitas/contratos"
                                loading={statsLoading}
                            />
                            <CardCountMetric
                                title="Perto do limite"
                                value={statsLoading ? '-' : stats.pertoDoLimite}
                                subtitle="Restam menos que 10"
                                loading={statsLoading}
                            />
                            <CardCountMetric
                                title="Inativadas"
                                value={statsLoading ? '-' : stats.inativadas}
                                loading={statsLoading}
                            />
                        </MetricsRow>

                        {layoutView === 'table' ? (
                            <TableWithLabelBlackV2
                                columns={columns}
                                data={arts}
                                showAll={true}
                                serverSide={true}
                                isLoading={loadingSearch}
                                itemsPerPage={arts.length || limit}
                                enableDefaultRowNavigation={false}
                                emptyMessage="Nenhum resultado encontrado."
                                actionsColumn={{
                                    enabled: true,
                                    position: "first",
                                    label: "AÇÕES",
                                    width: "100%",
                                    minWidth: "100px",
                                    maxWidth: "140px",
                                    justifyContent: "flex-start",
                                    render: (art) => (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Tooltip
                                                content="Editar ART/TRT"
                                                animation="fade"
                                                delay={[0, 100]}
                                                arrow
                                                theme="light"
                                                placement="bottom"
                                                appendTo={() => document.body}
                                                zIndex={99999}
                                            >
                                                <button
                                                    type="button"
                                                    aria-label="Editar ART/TRT"
                                                    onClick={() => this.handleEditArt(art)}
                                                    style={{ all: 'unset', display: 'flex', cursor: 'pointer' }}
                                                >
                                                    <img src={IconPenEdit} alt="Editar ART/TRT" style={{ width: '16px', height: '16px' }} />
                                                </button>
                                            </Tooltip>

                                            <Tooltip
                                                content="Ver receitas emitidas"
                                                animation="fade"
                                                delay={[0, 100]}
                                                arrow
                                                theme="light"
                                                placement="bottom"
                                                appendTo={() => document.body}
                                                zIndex={99999}
                                            >
                                                <button
                                                    type="button"
                                                    aria-label="Ver receitas emitidas"
                                                    onClick={() => this.handleVerReceitasEmitidas(art)}
                                                    style={{ all: 'unset', display: 'flex', cursor: 'pointer' }}
                                                >
                                                    <img src={IconOrder} alt="" style={{ width: '18px', height: '18px' }} />
                                                </button>
                                            </Tooltip>

                                            <MoreOptions
                                                loading={downloadingArtId === art.id}
                                                OneOptionIcon={<DownloadIcon />}
                                                OneOptionText="Baixar documento"
                                                OneOptionAction={() => this.handleBaixarDocumento(art)}

                                                {...(Number(art.status) === 0 ? {
                                                    TwoOptionIcon: <CheckCircleIcon />,
                                                    TwoOptionText: "Ativar ART/TRT",
                                                    TwoOptionAction: () => this.handleAtivarArt(art),
                                                    TwoOptionDivider: true,
                                                    TwoOptionSuccess: true
                                                } : {
                                                    TwoOptionIcon: <BanIcon />,
                                                    TwoOptionText: "Inativar ART/TRT",
                                                    TwoOptionAction: () => this.handleInativarArt(art),
                                                    TwoOptionDivider: true,
                                                    TwoOptionDanger: true
                                                })}
                                            />
                                        </div>
                                    )
                                }}
                            />
                        ) : (
                            <CardsGrid>
                                {arts.map((art) => {
                                    const isAtivo = Number(art.status) === 1;
                                    const isVencida = Number(art.status) === 2;
                                    const nome = art?.crea?.agronomo?.nome || '-';
                                    const tipo = art?.crea?.tipo;
                                    const creaNum = art?.crea?.crea || '-';
                                    const creaLabel = tipo === 'crea' ? `Crea: ${creaNum}` : tipo === 'visto' ? `Visto: ${creaNum}` : `Cfta: ${creaNum}`;
                                    const codigo = `${art.numero_art}${art.apelido ? ` - ${art.apelido}` : ''}`;
                                    const loja = art?.crea?.agronomo?.filial?.nome_fantasia || '';
                                    const disabledColor = theme.colors.disabled.Desabilitado_Medio;
                                    const receitasInfo = this.getReceitasInfo(art);
                                    const isPertoDoLimite = receitasInfo.denominator > 0 && (receitasInfo.denominator - receitasInfo.numerator) <= 10;
                                    const estado = formatarEstado(art?.crea?.estado);
                                    const pillVariant = !isAtivo ? 'inativo' : (isEstadoNacional(art?.crea?.estado) ? 'nacional' : 'default');
                                    // Estado "default" usa o Badge do jeito que ele já vem (fundo Cinza_2,
                                    // texto branco) - só "Nacional" e "inativo" sobrescrevem a cor.
                                    const pillColors = pillVariant === 'nacional'
                                        ? { bg: theme.colors.blue.fundo, text: theme.colors.blue.Azul_link }
                                        : pillVariant === 'inativo'
                                            ? { bg: theme.colors.red.Vermelho_erro, text: theme.colors.white.Branco }
                                            : { bg: undefined, text: undefined };

                                    return (
                                        <ArtCard key={art.id}>
                                            <ArtCardTopRow>
                                                <ArtCardTitle disabled={!isAtivo}>{nome}</ArtCardTitle>

                                                <ArtCardHeaderRight>
                                                    <TextOrStatus
                                                        type="status"
                                                        status={isAtivo ? 2 : 3}
                                                        textSuccess="Ativo"
                                                        textError={isVencida ? "Vencida" : "Inativo"}
                                                        maxWidth="auto"
                                                    />

                                                    <Badge color={pillColors.bg} textColor={pillColors.text}>
                                                        {estado}
                                                    </Badge>

                                                    <MoreOptions
                                                        loading={downloadingArtId === art.id}
                                                        OneOptionIcon={<img src={IconPenEdit} alt="" style={{ width: '18px', height: '18px' }} />}
                                                        OneOptionText="Editar ART/TRT"
                                                        OneOptionAction={() => this.handleEditArt(art)}

                                                        TwoOptionIcon={<DownloadIcon />}
                                                        TwoOptionText="Baixar documento"
                                                        TwoOptionAction={() => this.handleBaixarDocumento(art)}

                                                        ThreeOptionIcon={<img src={IconOrder} alt="" style={{ width: '18px', height: '18px' }} />}
                                                        ThreeOptionText="Ver receitas emitidas"
                                                        ThreeOptionAction={() => this.handleVerReceitasEmitidas(art)}

                                                        {...(Number(art.status) === 0 ? {
                                                            FourOptionIcon: <CheckCircleIcon />,
                                                            FourOptionText: "Ativar ART/TRT",
                                                            FourOptionAction: () => this.handleAtivarArt(art),
                                                            FourOptionDivider: true,
                                                            FourOptionSuccess: true
                                                        } : {
                                                            FourOptionIcon: <BanIcon />,
                                                            FourOptionText: "Inativar ART/TRT",
                                                            FourOptionAction: () => this.handleInativarArt(art),
                                                            FourOptionDivider: true,
                                                            FourOptionDanger: true
                                                        })}
                                                    />
                                                </ArtCardHeaderRight>
                                            </ArtCardTopRow>

                                            <TaglineP color={isAtivo ? theme.colors.gray.Cinza_6 : disabledColor} fontWeight={600}>
                                                {creaLabel}
                                            </TaglineP>

                                            <ArtCardCodeRow>
                                                <ArtCardCode disabled={!isAtivo}>
                                                    {isAtivo ? codigo : <strike>{codigo}</strike>}
                                                </ArtCardCode>

                                                {loja && (
                                                    <Badge
                                                        color={theme.colors.blue.Ceu}
                                                        textColor={theme.colors.white.Branco}
                                                        style={{ width: 'auto', alignSelf: 'flex-start' }}
                                                    >
                                                        {loja}
                                                    </Badge>
                                                )}
                                            </ArtCardCodeRow>

                                            {art.data_validade && (
                                                <ArtCardValidade disabled={!isAtivo}>
                                                    Validade: <b>{this.formatDateBR(art.data_validade)}</b>
                                                </ArtCardValidade>
                                            )}

                                            <ArtCardProgressRow>
                                                <ArtCardProgressTrack>
                                                    <ArtCardProgressFill percent={receitasInfo.percent} warning={isAtivo && isPertoDoLimite} disabled={!isAtivo} />
                                                </ArtCardProgressTrack>

                                                <ArtCardProgressLabel disabled={!isAtivo}>
                                                    {receitasInfo.numerator} / {receitasInfo.denominator} <i>{receitasInfo.label}</i>
                                                </ArtCardProgressLabel>
                                            </ArtCardProgressRow>
                                        </ArtCard>
                                    );
                                })}

                                {loadingSearch && (
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                                        <Loading size="48px" color={theme.colors.green.Verde_AgroReceita} />
                                    </div>
                                )}

                                {!loadingSearch && arts.length === 0 && (
                                    <NotFound message="Nenhum resultado encontrado." />
                                )}
                            </CardsGrid>
                        )}

                        <PaginatorV2
                            perPage={limit}
                            total={totalPages}
                            onChange={(limit, offset) => this.updateLimitOffset(limit, offset)}
                            totalItens={arts.length}
                        />

                        {modalTesteGratisAcabou ? (
                            <ModalTesteGratisAcabou
                                show={modalTesteGratisAcabou}
                                title="Essa é uma função exclusiva para assinantes..."
                                subtitle="Assine o Agroreceita para desbloquear todos os recursos abaixo:"
                                onHide={() => {
                                    this.setState({ modalTesteGratisAcabou: false })
                                    this.props.history.push('/');
                                }}
                            ></ModalTesteGratisAcabou>

                        ) : (null)}
                    </Container>
                </ArtsContainer>

                <ModalGeneric
                    show={modalRelatorio}
                    onHide={() => this.setState({ modalRelatorio: false })}
                    title="Gerar Relatório"
                    subtitle="O relatório será enviado para o seu e-mail cadastrado."
                >
                    <H5 style={{ textAlign: 'center', paddingBottom: '20px' }}>Relatório gerado com sucesso!</H5>
                    <BodyM style={{ textAlign: 'center' }}>O relatório será enviado para o e-mail</BodyM>
                    <BodyM style={{ textAlign: 'center', paddingBottom: '20px' }}><b>{emailUser.username}</b>.</BodyM>
                    <Button
                        width='100%'
                        height='50px'
                        value='FECHAR'
                        outline={false}
                        disabled={false}
                        onClick={() => this.setState({ modalRelatorio: false })}
                    />
                </ModalGeneric>

                <ModalGeneric
                    show={!!modalInativarArt}
                    onHide={this.handleCancelInativarArt}
                    title="Inativar ART/TRT"
                    subtitle="Essa ação não poderá ser desfeita."
                    marginBottom="0px"
                >
                    <H5 style={{ textAlign: 'center', paddingBottom: '20px' }}>Inativar ART/TRT?</H5>
                    <BodyM style={{ textAlign: 'center', paddingBottom: '20px' }}>
                        Tem certeza que deseja inativar a ART/TRT <b>{modalInativarArt?.numero_art}</b>{modalInativarArt?.apelido ? ` - ${modalInativarArt.apelido}` : ''}? Essa ação não poderá ser desfeita.
                    </BodyM>
                    <div style={{ width: '100%', display: 'flex', gap: '12px' }}>
                        <Button
                            width='100%'
                            height='50px'
                            value='CANCELAR'
                            outline={true}
                            color={theme.colors.gray.Cinza_2}
                            disabled={togglingArtStatus}
                            onClick={this.handleCancelInativarArt}
                        />
                        <Button
                            width='100%'
                            height='50px'
                            value='INATIVAR'
                            outline={false}
                            red={true}
                            disabled={togglingArtStatus}
                            loading={togglingArtStatus}
                            onClick={this.handleConfirmInativarArt}
                        />
                    </div>
                </ModalGeneric>

                <ModalGeneric
                    show={!!modalAtivarArt}
                    onHide={this.handleCancelAtivarArt}
                    title="Ativar ART/TRT"
                    subtitle="A ART/TRT volta a ficar disponível para uso."
                    marginBottom="0px"
                >
                    <H5 style={{ textAlign: 'center', paddingBottom: '20px' }}>Ativar ART/TRT?</H5>
                    <BodyM style={{ textAlign: 'center', paddingBottom: '20px' }}>
                        Tem certeza que deseja ativar a ART/TRT <b>{modalAtivarArt?.numero_art}</b>{modalAtivarArt?.apelido ? ` - ${modalAtivarArt.apelido}` : ''}? Ela volta a ficar disponível para uso.
                    </BodyM>
                    <div style={{ width: '100%', display: 'flex', gap: '12px' }}>
                        <Button
                            width='100%'
                            height='50px'
                            value='CANCELAR'
                            outline={true}
                            color={theme.colors.gray.Cinza_2}
                            disabled={togglingArtStatus}
                            onClick={this.handleCancelAtivarArt}
                        />
                        <Button
                            width='100%'
                            height='50px'
                            value='ATIVAR'
                            outline={false}
                            disabled={togglingArtStatus}
                            loading={togglingArtStatus}
                            onClick={this.handleConfirmAtivarArt}
                        />
                    </div>
                </ModalGeneric>
            </>
        );
    }
}

export default withRouter(Arts);
